import clsx from "clsx";
import React, { useMemo } from "react";

import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { formatMessage } from "@app/translations/intl";
import { RelAttributes } from "@app/constants";
import { DealLike } from "@app/components/deal-cards/deal-like/deal-like";
import { ImageComponent } from "@app/core/image/image.component";
import { CurrencyComponent } from "@app/core/currency/currency.component";
import { ClickableComponent } from "@app/core/clickable";
import { DataWarehouseProductDTO } from "@app/bf-api";

import styles from "./deal-card-alert.module.scss";
import { toEan13 } from "@app/util/ean-13";

export interface IDealCardAlertProps {
  deal: DataWarehouseProductDTO;
  responsive?: boolean;
  isSponsored?: boolean;
  className?: string;
}

export const DealCardAlert = (props: IDealCardAlertProps) => {
  const { image_url, merchant, name, price, ean } = props.deal;

  const outUrl = useMemo(() => `/out/wishlist/${toEan13(ean)}`, [ean]);

  return (
    <div className={clsx(styles.dealCard, props.responsive && styles.responsive, props.className)}>
      <DealLike deal={props.deal} removeIcon />
      <a rel="sponsored" target="_blank" href={outUrl} className={styles.leftSection}>
        {props.isSponsored && (
          <div className={styles.sponsored}>{formatMessage({ id: "dealCard.sponsoredLabel" })}</div>
        )}
        <div className={styles.image}>
          <ImageComponent src={image_url} alt={name} title={name} isBlocking />
        </div>
        <div className={styles.price}>
          {!!price && (
            <div className={styles.priceBox}>
              <div className={clsx(styles.priceNew)}>
                <CurrencyComponent value={Number(price)} variant="new" />
              </div>
            </div>
          )}
        </div>
      </a>
      <div className={styles.rightSection}>
        <a rel="sponsored" target="_blank" href={outUrl} className={styles.rightSectionLink}>
          <div className={styles.content}>
            <div className={styles.subtitleWrapper}>
              {merchant && (
                <span title={merchant} className={styles.merchantName}>
                  {merchant}
                </span>
              )}
            </div>

            <div className={styles.titleWrapper}>
              <span className={styles.title}>
                <h4 title={name}>{name}</h4>
              </span>
            </div>
          </div>

          <div className={styles.action}>
            <ClickableComponent
              title={formatMessage({ id: "dealCard.button.toCampaignPageOut" })}
              variant="primary-2025"
              iconStyle="filled"
              iconRight={IcnChevronRight}
              iconSize="12px"
              fullWidth
              isNonClickable
              relAttribute={RelAttributes.SPONSORED}
            />
          </div>
        </a>
      </div>
    </div>
  );
};
